var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcoRu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#8DD555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7579 12.151L14.9077 11.4468C12.7421 9.39121 8.58288 7.70173 6.74635 7.63171C8.6709 7.00753 11.8678 8.76203 13.2522 9.79433C11.6107 5.24203 7.36253 3.65057 2 7.88678C3.12132 8.06984 5.16791 13.5254 11.6278 11.2427C13.1592 10.7016 14.3125 10.9777 16 12.4991C15.927 12.3831 15.846 12.267 15.7579 12.151ZM2.87925 7.89879C4.17662 7.50667 5.53401 11.2988 12.467 10.7156C5.42898 12.4391 3.57645 7.78976 2.87925 7.89879Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3602 7.17062C13.2642 8.12689 14.0654 9.50229 14.5735 10.3045C17.0403 7.71277 13.5192 6.01029 14.7536 5C12.0108 6.93155 12.9781 9.25922 14.9076 11.4458L15.7579 12.15C12.4469 8.52401 13.3512 7.26865 13.3602 7.17062ZM14.2725 5.73521C14.0394 6.12432 16.2 7.50672 14.6726 10.0224C15.7059 7.83581 13.8223 6.18534 14.2725 5.73521Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoRu);
export default __webpack_public_path__ + "static/media/eco-ru.b1e1c3bc907c3897835fa8efa5f139e4.svg";
export { ForwardRef as ReactComponent };